import { truncateTextWithEllipsis } from '@utilities';

/**
 * gets option label based on prompt description
 * @param {Object} params - The parameters object.
 * @param {number} params.length - The maximum length for truncating the parent text (optional).
 * @param {Object} params.option - The option object to generate the label for.
 * @return {String|Node}
 */
export const getOptionLabel = ({ length, option }) => {
  if (!option) return '';

  const [rawParent, rawChild] = option?.prompt_desc?.split(' || ') || [];
  const parent = rawParent?.trim();
  const child = rawChild?.replace(`(${parent})`, '').trim();

  if (child) {
    const truncatedParent = length ? truncateTextWithEllipsis({ length, text: parent }) : parent;

    return (
      <>
        {child}
        <span>&nbsp;- {truncatedParent}</span>
      </>
    );
  }

  if (option?.operatorInfo) return option?.metric?.name;

  return option?.name || '';
};
